import store from '@/stores/store';
import { ModuleContext } from '@/stores/moduleConst';
import monitorApi from '@/apis/monitor/monitorApi.js';
import i18nGlobal from '@/i18ns/i18n';
const i18n = i18nGlobal.global;
import { MSConstant } from '@/commons/wildcards/index.js';
import commonFunc from '@/commons/commonFunction.js';

export const collectionMonitor = () => {
  /**
   * Đẩy thông tin lên mcp
   * @param {*} type Loại monitor, 1 - login, 2 - Transaction, 3 - định kỳ
   * @param {*} eventId Mã event 1- Thêm,... Định nghĩa trong enum
   * @param {*} screenCode Mã màn hình => Định nghĩa trong enum
   * HTHIEP 15.11.2022
   * lhphong 28.12.2023 - thêm function param cho custom eventName
   */
  const push = (type, event, screenName, screenCode, callBackFn) => {
    try {
      const context = store.state[ModuleContext];
      let contextData = context.Context ? context.Context : {};
      const eventId = getEventId(event);
      const eventName = (typeof callBackFn == 'function') ? callBackFn(event) : getEventName(event);
      const name = screenName || getScreenName(screenCode);
      if (!eventId || !name || !eventName) {
        console.warn('monitor data not ready!');
        return;
      }
      const metaData = {
        BudgetCode: contextData.BudgetCode, //Hoặc sử dụng trường BudgetCode, CustomerPhone,  IdentityNumber, BusinessRegistrationCode, PersonalTaxCode
        UserId: contextData.UserID,
        EventId: eventId,
        EventName: eventName,
        ScreenName: name,
        ScreenCode: screenCode,
        Type: type,
        Version: window._appversion,
        SubscriberNo: contextData.SubscriberNo,
      };

      monitorApi.push(metaData);
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * Push thông tin transaction lên monitor => tích hợp mcp
   * @param {*} eventId
   * @param {*} screenCode
   * HTHIEP 15.11.2022
   */
  const pushTrans = (eventId, screenName, screenCode, callBackFn) => {
    push(2, eventId, screenName, screenCode, callBackFn);
  };

  /**
   * Push khi login lên monitor => tích hợp mcp
   * HTHIEP 15.11.2022
   */
  const pushLogin = () => {
    push(1, 'login', '', MSConstant.ScreenCode.Login);
  };

  /**
   * Lấy thông tin màn hình theo code
   * @param {*} code
   * @returns
   */
  const getScreenName = code => {
    return commonFunc.getScreen(code);
  };

  /**
   * Lấy tên eventId từ command đang thao tác
   * @param {*} id
   * @returns
   */
  const getEventName = event => {
    if (!event) {
      throw 'Không tìm được command trong cấu hình';
    }
    if (event === 'login') {
      return 'Đăng nhập';
    }
    const localize = i18n;
    const eventName = localize.t(`i18nMonitor.EventName.${event}`);
    if (!eventName) {
      // return '';
      console.error('Chưa định nghĩa eventName tại i18n');
    }

    if (eventName.indexOf('i18nMonitor') !== -1) {
      // return '';
      console.error('Chưa định nghĩa eventName tại i18n');
      throw 'Chưa định nghĩa eventName tại i18n';
    }

    return eventName;
  };

  /**
   * Lấy tên eventId từ command đang thao tác
   * @param {*} id
   * @returns
   */
  const getEventId = event => {
    if (event === 'login') {
      return 999;
    }
    const eventId = MSConstant.EventId[event];
    if (typeof eventId !== 'number') {
      console.error('Chưa định nghĩa EventId');
    }
    return eventId;
  };
  return { pushTrans, pushLogin };
};
